/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var RotateSquareRightIcon32Regular = forwardRef('RotateSquareRightIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M13.636.728a1 1 0 1 0-1.272 1.544L14.463 4H9.5A6.5 6.5 0 0 0 3 10.5V15a1 1 0 1 0 2 0v-4.5A4.5 4.5 0 0 1 9.5 6h4.963l-2.099 1.728a1 1 0 0 0 1.272 1.544l3.312-2.728a2 2 0 0 0 0-3.088L13.636.728Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9 17a5 5 0 0 1 5-5h8a5 5 0 0 1 5 5v8a5 5 0 0 1-5 5h-8a5 5 0 0 1-5-5v-8Zm5-3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3v-8a3 3 0 0 0-3-3h-8Z" })));
});
